import script from "./P404.vue?vue&type=script&lang=ts&setup=true"
export * from "./P404.vue?vue&type=script&lang=ts&setup=true"

import "./P404.vue?vue&type=style&index=0&id=acb1c088&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb1c088"]])

export default __exports__